import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, renderSlot as _renderSlot } from "vue"
import _imports_0 from '@/app/ui/assets/svg/dashboard.svg'


const _hoisted_1 = {
  key: 1,
  id: "breadcrumb",
  class: "flex flex-col bg-white w-full"
}
const _hoisted_2 = { class: "flex overflow-hidden flex-row items-center text-12px xxl:text-14px text-gray-lp-500" }
const _hoisted_3 = {
  key: 0,
  class: "flex flex-row items-center"
}
const _hoisted_4 = {
  class: "mx-1 flex items-center w-max",
  style: {"padding-left":"5.33px","padding-right":"5.33px"}
}
const _hoisted_5 = {
  key: 1,
  class: "flex flex-row items-center"
}
const _hoisted_6 = {
  class: "mx-1 flex items-center w-max",
  style: {"padding-left":"5.33px","padding-right":"5.33px"}
}
const _hoisted_7 = { class: "text-red-lp-100" }
const _hoisted_8 = {
  key: 2,
  class: "flex flex-row items-center"
}
const _hoisted_9 = {
  class: "mx-1 flex items-center w-max",
  style: {"padding-left":"5.33px","padding-right":"5.33px"}
}
const _hoisted_10 = {
  key: 3,
  class: "flex flex-row items-center"
}
const _hoisted_11 = {
  class: "mx-1 flex items-center w-max",
  style: {"padding-left":"5.33px","padding-right":"5.33px"}
}
const _hoisted_12 = {
  key: 1,
  class: "flex items-center"
}
const _hoisted_13 = {
  class: "mx-1 flex items-center w-max",
  style: {"padding-left":"5.33px","padding-right":"5.33px"}
}
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  class: "mx-1 flex items-center w-max",
  style: {"padding-left":"5.33px","padding-right":"5.33px"}
}
const _hoisted_16 = {
  class: "mx-1 flex items-center w-max",
  style: {"padding-left":"5.33px","padding-right":"5.33px"}
}
const _hoisted_17 = { class: "text-red-lp-100 font-bold" }
const _hoisted_18 = {
  key: 2,
  class: "flex items-center"
}
const _hoisted_19 = {
  class: "mx-1 flex items-center w-max",
  style: {"padding-left":"5.33px","padding-right":"5.33px"}
}
const _hoisted_20 = { class: "text-red-lp-100 font-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BreadcrumbV2 = _resolveComponent("BreadcrumbV2")!
  const _component_Icons = _resolveComponent("Icons")!

  return (_ctx.isSidebarAndBreadcrumbV2)
    ? (_openBlock(), _createBlock(_component_BreadcrumbV2, {
        key: 0,
        "custom-breadcrumb-title": _ctx.customBreadcrumbTitle
      }, null, 8, ["custom-breadcrumb-title"]))
    : (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("img", {
            src: _imports_0,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goHome && _ctx.goHome(...args))),
            class: "w-5 cursor-pointer",
            alt: "dashboard"
          }),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getCurrentRoute?.matched, (item, index) => {
            return (_openBlock(), _createBlock("div", {
              key: index,
              class: ["flex flex-row font-medium", { 'font-semibold text-sm': _ctx.isSemiboldBreadcrumb }]
            }, [
              (!item.meta.children && index === 0)
                ? (_openBlock(), _createBlock("div", _hoisted_3, [
                    _createVNode("span", _hoisted_4, [
                      _createVNode(_component_Icons, {
                        name: "chevron-right-thin",
                        style: {"width":"6px"}
                      })
                    ]),
                    _createVNode("div", {
                      class: 
              `${_ctx.nameUpdateFeature(item.meta.name) ===
                _ctx.getCurrentRoute.meta.name &&
                !_ctx.isDashboardDetail &&
                _ctx.decideBreadcrumbColor} hover:${_ctx.decideBreadcrumbColor} ${
                _ctx.isDashboardDetail ? 'cursor-pointer' : ''
              }`
            ,
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isDashboardDetail ? _ctx.goHome() : {}))
                    }, _toDisplayString(_ctx.translatedFeatureName(
                (item.meta.customName || item.meta.name) ?? ""
              )), 3)
                  ]))
                : _createCommentVNode("", true),
              (!!_ctx.customBreadcrumbTitle && index === 0)
                ? (_openBlock(), _createBlock("div", _hoisted_5, [
                    _createVNode("span", _hoisted_6, [
                      _createVNode(_component_Icons, {
                        name: "chevron-right-thin",
                        style: {"width":"6px"}
                      })
                    ]),
                    _createVNode("div", _hoisted_7, _toDisplayString(_ctx.customBreadcrumbTitle), 1)
                  ]))
                : _createCommentVNode("", true),
              (item.meta.children)
                ? (_openBlock(), _createBlock("div", _hoisted_8, [
                    _createVNode("span", _hoisted_9, [
                      _createVNode(_component_Icons, {
                        name: "chevron-right-thin",
                        style: {"width":"6px"}
                      })
                    ]),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.children, (item, index) => {
                      return (_openBlock(), _createBlock("div", { key: index }, [
                        _withDirectives(_createVNode("div", {
                          class: 
                `${_ctx.nameUpdateFeature(item.meta.name) ===
                  _ctx.getCurrentRoute.meta.name &&
                  'text-red-lp-100 font-bold'} hover:text-red-lp-100`
              
                        }, _toDisplayString(_ctx.translatedFeatureName(
                  (item.meta.customName || item.meta.name) ?? ""
                )), 3), [
                          [_vShow, 
                _ctx.nameUpdateFeature(item.meta.name) === _ctx.getCurrentRoute.meta.name
              ]
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (item.meta.parent)
                ? (_openBlock(), _createBlock("div", _hoisted_10, [
                    _withDirectives(_createVNode("span", _hoisted_11, [
                      _createVNode(_component_Icons, {
                        name: "chevron-right-thin",
                        style: {"width":"6px"}
                      })
                    ], 512), [
                      [_vShow, item.meta.name]
                    ]),
                    (index !== _ctx.getCurrentRoute?.matched.length - 1)
                      ? (_openBlock(), _createBlock("div", {
                          key: 0,
                          class: "hover:text-red-lp-100 cursor-pointer",
                          onClick: () => _ctx.goPath(item.meta['parent-path'] || item.path)
                        }, _toDisplayString(_ctx.translatedFeatureName(item.meta.parent ?? "")), 9, ["onClick"]))
                      : _createCommentVNode("", true),
                    (item.children[0]?.meta?.before)
                      ? (_openBlock(), _createBlock("div", _hoisted_12, [
                          _createVNode("span", _hoisted_13, [
                            _createVNode(_component_Icons, {
                              name: "chevron-right-thin",
                              style: {"width":"6px"}
                            })
                          ]),
                          _createVNode("div", {
                            class: "cursor-pointer hover:text-red-lp-100 flex flex-row items-center",
                            onClick: 
                () =>
                  _ctx.goDetail(
                    item.children[0]?.meta?.before,
                    _ctx.getCurrentRoute.params.id
                  )
              
                          }, [
                            (_ctx.params.params)
                              ? (_openBlock(), _createBlock("span", {
                                  key: 0,
                                  class: 
                  `text-red-lp-100 font-bold ${_ctx.id &&
                    index !== _ctx.getCurrentRoute?.matched.length - 1}`
                
                                }, _toDisplayString(_ctx.params.params), 3))
                              : (item.children[0].meta.pathBefore)
                                ? (_openBlock(), _createBlock("span", _hoisted_14, _toDisplayString(item.children[0].meta.pathBefore), 1))
                                : (_openBlock(), _createBlock("span", {
                                    key: 2,
                                    class: 
                  `${_ctx.id && index !== _ctx.getCurrentRoute?.matched.length - 1}`
                
                                  }, _toDisplayString(_ctx.id), 3))
                          ], 8, ["onClick"]),
                          _withDirectives(_createVNode("span", _hoisted_15, [
                            _createVNode(_component_Icons, {
                              name: "chevron-right-thin",
                              style: {"width":"6px"}
                            })
                          ], 512), [
                            [_vShow, _ctx.id && item.meta.parent && !_ctx.params.params]
                          ]),
                          _withDirectives(_createVNode("span", { class: "text-red-lp-100 font-bold" }, _toDisplayString(!item.children[0].meta.title
                  ? _ctx.$route.params.id
                  : _ctx.$t(item.children[0].meta.name ?? "")), 513), [
                            [_vShow, !_ctx.params.params]
                          ]),
                          (item.children[0].meta.lastBreadCrumb)
                            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                _createVNode("span", _hoisted_16, [
                                  _createVNode(_component_Icons, {
                                    name: "chevron-right-thin",
                                    style: {"width":"6px"}
                                  })
                                ]),
                                _createVNode("span", _hoisted_17, _toDisplayString(_ctx.$t(item.children[0].meta.lastBreadCrumb ?? "")), 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_18, [
                          _createVNode("span", _hoisted_19, [
                            _createVNode(_component_Icons, {
                              name: "chevron-right-thin",
                              style: {"width":"6px"}
                            })
                          ]),
                          _createVNode("span", _hoisted_20, _toDisplayString(_ctx.id), 1)
                        ]))
                  ]))
                : _createCommentVNode("", true)
            ], 2))
          }), 128))
        ]),
        _renderSlot(_ctx.$slots, "additional-label")
      ]))
}